import { render } from "./cwbg.vue?vue&type=template&id=36e417b2&scoped=true&ts=true"
import script from "./cwbg.vue?vue&type=script&lang=ts"
export * from "./cwbg.vue?vue&type=script&lang=ts"

import "./cwbg.vue?vue&type=style&index=0&id=36e417b2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e417b2"]])

export default __exports__